import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../hooks';
import { useField } from '@unform/core';
import { SubGrupoProdutoService } from '../services/api/estoque/subGrupoProduto/SubGrupoProdutoService';

type TAutoCompleteOption = {
  idsubgrupo: string;
  label: string;
}

interface IAutoCompleteSubgruposProps {
  isExternalLoading?: boolean;
  idgrupo?: string;
}

export const AutoCompleteSubgrupoProdutos: React.FC<IAutoCompleteSubgruposProps> = ({ isExternalLoading = false, idgrupo = '56e0903a-c6d0-4c6d-8ef6-72e60d40e300' }) => {

  const { fieldName, registerField, defaultValue, error, clearError } = useField('idsubgrupo');

  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<string | undefined>(defaultValue);

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);

  const [isLoading, setIsLoading] = useState(false);
  
  const [busca, setBusca] = useState('');

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => selectedId,
      setValue: (_, newSelectedId) => setSelectedId(newSelectedId),
    });
  }, [registerField, fieldName, selectedId]);

  useEffect(() => {
    setSelectedId(undefined);
    setBusca('');
  }, [idgrupo]);

  useEffect(() => {
    setIsLoading(true);
    debounce(() => {
      if(selectedId !== null){

        SubGrupoProdutoService.getAllList(idgrupo, busca, selectedId)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            //alert(result.message);
          } else {
            setOpcoes(result.data.map(veiculos => ({ idsubgrupo: veiculos.idsubgrupo, label: veiculos.descricao })));
          }
        });
      }setIsLoading(false);
      
    });
  },[idgrupo, busca, selectedId]);
 
  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.idsubgrupo === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);
  
  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...' 
      fullWidth
      disablePortal
      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      // Só busca sozinho por `reason==='input'` — ver AutoCompleteMunicipio.tsx pro caso
      // completo do loop que isso evita (reset automático do MUI virando busca).
      onInputChange={(_, newValue, reason) => {
        if (reason === 'input') setBusca(newValue);
      }}
      onChange={(_, newValue) => { setSelectedId(newValue?.idsubgrupo); setBusca(''); clearError(); }}
      popupIcon={(isExternalLoading || isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Subgrupo"
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};